import classNames from "classnames";
import React from "react";
import "./CircleDots.scss";

interface Props {
  className?: string;
  centerX: string;
  centerY: string;
  radius: string;
  colour: "light" | "grey" | "dark-grey";
  zIndex?: "behind" | "in-front";
}

/**
 * Component to draw a circle of dots.
 * 
 * @status stable
 */
export const CircleDots: React.FC<Props> = ({ centerX, centerY, radius, zIndex, colour, className }) => {
  return (
    <svg className={classNames("circle-dots", className, { [`circle-dots--${zIndex}`]: zIndex != null })}>
      <circle className={classNames("circle-dots__dots", `circle-dots__dots--${colour}`)} cx={centerX} cy={centerY} r={radius} />
    </svg>
  );
};

CircleDots.defaultProps = {
  colour: "dark-grey",
};
